import type { InpaintPresentation } from '@genieartinc/schemas/pools/ai'

/** Image and Mask rows for Node controls. Only mounted for an Inpaint node. */
export function InpaintInputs({ view }: { view: InpaintPresentation }) {
  return (
    <div className="space-y-3 border-t border-border px-3 py-3" data-testid="inpaint-inputs">
      <p className="text-sm font-semibold">Inputs</p>
      {view.roles.map((role) => (
        <div key={`${role.role}:${role.handleId ?? role.label}`} className="space-y-1" role="group" aria-label={role.label}>
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm">{role.label}</span>
            <span className="text-xs text-muted-foreground">
              {role.requirement === 'required' ? 'Required' : 'Optional'}
              {role.status === 'connected' ? ' · Connected' : role.status === 'loading' ? ' · Loading' : role.status === 'error' ? ' · Error' : ' · Not connected'}
            </span>
          </div>
          {role.url ? (
            <img src={role.url} alt={role.label} className="max-h-24 w-full rounded bg-muted object-contain" />
          ) : (
            <p className="text-xs text-muted-foreground">{role.message}</p>
          )}
        </div>
      ))}
      {view.limitation && <p className="text-xs text-muted-foreground">{view.limitation}</p>}
      {view.blockReason && <p className="text-xs text-muted-foreground">{view.blockReason}</p>}
    </div>
  )
}
